document.addEventListener("DOMContentLoaded", function () {
  initializeCarousels();

  function initializeCarousels() {
    const carousels = document.querySelectorAll(".manitoba-carousel .swiper");

    carousels.forEach(function (carousel) {
      const slides = carousel.querySelectorAll(".swiper-slide");

      if (slides.length < 2) {
        return;
      }

      const autoplayDelay = carousel.parentElement.dataset.autoplayDelay || 5000;

      const swiperConfig = {
        slidesPerView: 1,
        spaceBetween: 30,
        autoplay: {
          delay: autoplayDelay,
          disableOnInteraction: false,
        }
      };

      const paginationEl = carousel.querySelector(".swiper-pagination");
      if (paginationEl) {
        swiperConfig.pagination = {
          el: paginationEl,
          clickable: true,
        };
      }

      // Récupérer l'ID du conteneur parent
      const carouselContainer = carousel.closest('.manitoba-carousel');
      const carouselId = carouselContainer ? carouselContainer.id : null;
      
      // Sélectionner les boutons de navigation avec l'ID du conteneur
      const nextEl = carouselId ? document.querySelector(`[data-nav-next="${carouselId}"]`) : null;
      const prevEl = carouselId ? document.querySelector(`[data-nav-prev="${carouselId}"]`) : null;
      if (nextEl && prevEl) {
        swiperConfig.navigation = {
          nextEl: nextEl,
          prevEl: prevEl,
        };
      }

      new Swiper(carousel, swiperConfig);
    });
  }
});
